<template>
  <el-input v-model="input" :placeholder="placeholder" @keyup.native.enter="submit">
    <el-button class="searchType el-icon-takeaway-box"
      v-if="input !== ''"
      slot="prepend"
      @click="close">
    </el-button>
    <el-button class="searchType el-icon-warning-outline"
      v-else
      slot="prepend"
      @click="close">
    </el-button>
    <el-button
      slot="append"
      icon="fa fa-search"
      @click="submit">
    </el-button>
  </el-input>
</template>

<script>
import { apiRequest } from '../../backend/vue-axios/axios';
import {
  getRumDuration,
  startRumTiming,
  trackBusinessFlow,
} from '../../observability/datadogRum';

export default {
  props: {
    placeholder: {
      type: String,
      default: 'SOC O F12',
    },
    homeBtn: {
      type: Boolean,
      default: true,
    },
    reSearch: {
      type: Boolean,
      default: true,
    },
    valueInput: {
      type: Number,
      default: 0,
    },
    toSearch: {
      type: String,
    },
  },
  data() {
    return {
      input: '',
      type: 0,
      active: false,
      notFound: false,
    };
  },
  methods: {
    close() {
      this.$emit('restart', 0);
      this.$router.push({ name: 'TracingV1' });
    },
    checkInput(value) {
      if (value !== '') {
        return {
          module: 'tracing',
          service: 'suborder',
          params: {
            code: value,
          },
        };
      }
      this.$notify.error({
        title: 'Error',
        message: 'Ingrese una SOC o F12',
      });
      return { error: true };
    },
    submit() {
      this.$emit('clickSearchLupa', true);
      clearInterval(this.$options.interval);
      this.$emit('loaderSearch', true);
      const startedAt = startRumTiming();
      const data = this.checkInput(this.input);
      if (data.service === 'suborder' || data.service === 'customer') {
        this.$emit('type', 2);
        if (!data.error) {
          trackBusinessFlow({
            module: 'tracing',
            flow: 'suborder_tracking',
            action: 'search_requested',
            status: 'attempt',
          });
          apiRequest(data).then((res) => {
            this.notFound = false;
            this.$emit('loaderSearch', false);
            this.$emit('data', res.data);
            this.$emit('notFound', false);
            trackBusinessFlow({
              module: 'tracing',
              flow: 'suborder_tracking',
              action: 'search_completed',
              status: 'success',
              durationMs: getRumDuration(startedAt),
            });
            this.$options.interval = setInterval(() => {
              this.reSendData();
            }, 150000);
          }).catch((error) => {
            trackBusinessFlow({
              module: 'tracing',
              flow: 'suborder_tracking',
              action: 'search_completed',
              status: error.response && error.response.status === 404 ? 'empty' : 'error',
              durationMs: getRumDuration(startedAt),
              context: {
                http_status: error.response ? error.response.status : 0,
              },
            });
            if (error.response.status !== 404) {
              this.$notify.error({
                title: 'Error',
                message: 'Error en la búsqueda',
              });
            }
            this.notFound = true;
            this.$emit('loaderSearch', false);
            this.$emit('notFound', true);
          });
        }
      }
    },
    reSendData() {
      if (!this.notFound && this.reSearch) {
        if (this.input !== '') {
          const data = this.checkInput(this.input);
          if (data.service === 'suborder') {
            this.$emit('type', 2);
            const dataPackages = this.checkInput(this.input);
            if (!data.error) {
              apiRequest(dataPackages).then((res) => {
                this.$emit('data', res.data);
              }).catch((error) => {
                if (error.response.status !== 404) {
                  this.$notify.error({
                    title: 'Error',
                    message: 'Error en la búsqueda',
                  });
                }
              });
            }
          }
        }
      } else if (this.input === '') {
        clearInterval(this.$options.interval);
      }
    },
    actualizacion() {
      this.input = '';
    },
  },
  beforeMount() {
    if (this.$route.query.v) {
      this.input = this.$route.query.v;
      this.submit();
    } else if (this.$route.query.o) {
      this.input = this.$route.query.o;
      this.submit();
    }
  },
  beforeDestroy() {
    clearInterval(this.$options.interval);
  },
  watch: {
    input() {
      if (this.input === '') {
        this.$emit('active', 0);
        this.$emit('type', 0);
        this.$router.replace({ query: null });
      } else {
        this.$emit('active', 1);
      }
    },
    valueInput() {
      this.actualizacion();
    },
    toSearch() {
      this.input = this.toSearch;
      this.submit();
    },
  },
};
</script>

<style scoped>
  .searchType {
    padding-left: 10px;
    padding-right: 10px;
  }
</style>
